var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9827 4.64117L11.3588 1.01727C11.1472 0.806928 10.8613 0.688448 10.5629 0.6875H5.43711C5.13875 0.688448 4.85278 0.806928 4.64117 1.01727L1.01727 4.64117C0.806928 4.85278 0.688448 5.13875 0.6875 5.43711V10.5629C0.688448 10.8613 0.806928 11.1472 1.01727 11.3588L4.64117 14.9827C4.85278 15.1931 5.13875 15.3116 5.43711 15.3125H10.5629C10.8613 15.3116 11.1472 15.1931 11.3588 14.9827L14.9827 11.3588C15.1931 11.1472 15.3116 10.8613 15.3125 10.5629V5.43711C15.3116 5.13875 15.1931 4.85278 14.9827 4.64117ZM7.4375 4.625C7.4375 4.47582 7.49676 4.33274 7.60225 4.22725C7.70774 4.12176 7.85082 4.0625 8 4.0625C8.14918 4.0625 8.29226 4.12176 8.39775 4.22725C8.50324 4.33274 8.5625 4.47582 8.5625 4.625V8.5625C8.5625 8.71168 8.50324 8.85476 8.39775 8.96025C8.29226 9.06574 8.14918 9.125 8 9.125C7.85082 9.125 7.70774 9.06574 7.60225 8.96025C7.49676 8.85476 7.4375 8.71168 7.4375 8.5625V4.625ZM8 11.9375C7.83312 11.9375 7.66999 11.888 7.53124 11.7953C7.39248 11.7026 7.28434 11.5708 7.22048 11.4166C7.15662 11.2625 7.13991 11.0928 7.17246 10.9291C7.20502 10.7655 7.28538 10.6151 7.40338 10.4971C7.52138 10.3791 7.67172 10.2988 7.83539 10.2662C7.99906 10.2337 8.16871 10.2504 8.32289 10.3142C8.47706 10.3781 8.60884 10.4862 8.70155 10.625C8.79426 10.7637 8.84375 10.9269 8.84375 11.0938C8.84375 11.3175 8.75486 11.5321 8.59662 11.6904C8.43839 11.8486 8.22378 11.9375 8 11.9375Z",
    fill: "url(#paint0_linear_8120_15539)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8120_15539",
    x1: 0.6875,
    y1: 15.3125,
    x2: 18.0271,
    y2: 5.93408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC806"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6005A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoInfoIcon);
export default __webpack_public_path__ + "static/media/video-info-icon.ac3fc696fc3fc304c1e1627c202d5415.svg";
export { ForwardRef as ReactComponent };